<template>
  <div class="d-flex">
    <atom-custom-avatar
      :avatar-variant="avatarVariant"
      :avatar-border-style="avatarBorderStyle"
      :avatar-size="avatarSize"
      :avatar-icon="avatarIcon"
      :avatar-text="avatarText"
    ></atom-custom-avatar>
    <div class="mx-1">
      <span v-if="authorName" class="d-block text-medium-black font-size-12">
        {{ authorName }}
      </span>
      <span v-if="authorRole" class="d-block font-size-10">
        {{ authorRole }}
      </span>
    </div>
    <div v-if="datetime" class="pl-1 border-left">
      <span class="d-block font-size-12">
        {{ setDateTimeFormat(datetime, dateFormat) }}
      </span>
      <span class="d-block font-size-10">
        {{ setDateTimeFormat(datetime, timeFormat) }}
      </span>
    </div>
  </div>
</template>

<script>
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsDatetime from "@/mixins/mixinsDatetime"
import AtomCustomAvatar from "./AtomCustomAvatar.vue"

export default {
  name: "AtomAuthorAvatar",
  components: {
    AtomCustomAvatar,
  },
  mixins: [mixinsValidator, mixinsDatetime],
  props: {
    avatarVariant: {
      type: String,
      required: false,
      default: "light-primary",
    },
    avatarBorderStyle: {
      type: String,
      required: false,
      default: "circle",
    },
    avatarSize: {
      type: String,
      required: false,
      default: "md",
    },
    avatarIcon: {
      type: String,
      required: false,
      default: "UserIcon",
    },
    avatarText: {
      type: String,
      required: false,
      default: "",
    },
    authorName: {
      type: String,
      required: false,
      default: "",
    },
    authorRole: {
      type: String,
      required: false,
      default: "",
    },
    datetime: {
      type: String,
      required: false,
      default: "",
    },
    dateFormat: {
      type: String,
      required: false,
      default: "dd/MM/yyyy",
    },
    timeFormat: {
      type: String,
      required: false,
      default: "HH:mm",
    },
  },

  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="scss" scoped></style>
